export default __webpack_public_path__ + "static/media/rowdra.cb5cf8ed.jpg";